import {
  Facebook,
  Instagram,
  Mail,
  Youtube,
} from "lucide-react";


import { FaTiktok } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-8 grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-4">

        {/* LOGO + DESCRIPTION */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            {/* Replace with your logo */}
            <img
              src="/assets/Logo-HighEnd-Holidays-Gold-small.png"
              alt="Logo"
              className="h-9 w-auto"
            />
          </div>

          <p className="text-sm leading-relaxed">
            Premium apartment bookings with comfort, convenience, and reliability.
            Discover hand-picked stays and travel smarter.
          </p>
        </div>

        {/* COMPANY */}
        <div>
          <h4 className="font-semibold mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/about-us" className="hover:text-[#3a2a00]">About Us</a></li>
            <li><a href="/" className="hover:text-[#3a2a00]">Careers</a></li>
            <li><a href="/privacypolicy" className="hover:text-[#3a2a00]">Privacy Policy</a></li>
            <li><a href="/" className="hover:text-[#3a2a00]">Blog</a></li>
          </ul>
        </div>

        {/* SUPPORT */}
        <div>
          <h4 className=" font-semibold mb-3">Support</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-[#3a2a00]">Help Center</a></li>
            <li><a href="/" className="hover:text-[#3a2a00]">Safety Info</a></li>
            <li><a href="/cancellation-policy" className="hover:text-[#3a2a00]">Cancellation Policy</a></li>
            <li><a href="/contact-us" className="hover:text-[#3a2a00]">Contact Us</a></li>
          </ul>
        </div>

        {/* SOCIAL + CONTACT */}
        <div>
          <h4 className="font-semibold mb-3">Connect with us</h4>

          <div className="flex gap-3 mb-4">
            <a href="https://www.facebook.com/highend.holiday" className=" p-2 rounded-lg hover:bg-blue-600 transition">
              <Facebook size={18} />
            </a>
            <a href="https://www.instagram.com/highend.holidays/" className=" p-2 rounded-lg hover:bg-pink-500 transition">
              <Instagram size={18} />
            </a>
            <a href="https://www.tiktok.com/@highend.holidays" className=" p-2 rounded-lg hover:bg-blue-500 transition">
              <FaTiktok size={18} />
            </a>
            <a href="https://www.youtube.com/@highend.holidays" className=" p-2 rounded-lg hover:bg-blue-700 transition">
              <Youtube size={18} />
            </a>
          </div>

          <p className="text-sm flex items-center gap-2">
            <Mail size={16} /> info@highendholidays.ae
          </p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="border-t border-slate-800 text-center py-4 text-sm text-slate-500">
        © {new Date().getFullYear()} Highend Holidays Homes. All rights reserved.
      </div>
    </footer>
  );
}
